var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5.83268V5.16602C4 2.95688 5.79086 1.16602 8 1.16602C10.2091 1.16602 12 2.95688 12 5.16602V5.83268H13.3333C13.7015 5.83268 14 6.13116 14 6.49935V14.4993C14 14.8675 13.7015 15.166 13.3333 15.166H2.66667C2.29848 15.166 2 14.8675 2 14.4993V6.49935C2 6.13116 2.29848 5.83268 2.66667 5.83268H4ZM12.6667 7.16602H3.33333V13.8327H12.6667V7.16602ZM7.33333 10.9876C6.9348 10.7571 6.66667 10.3262 6.66667 9.83268C6.66667 9.09628 7.2636 8.49935 8 8.49935C8.7364 8.49935 9.33333 9.09628 9.33333 9.83268C9.33333 10.3262 9.0652 10.7571 8.66667 10.9876V12.4993H7.33333V10.9876ZM5.33333 5.83268H10.6667V5.16602C10.6667 3.69326 9.47273 2.49935 8 2.49935C6.52724 2.49935 5.33333 3.69326 5.33333 5.16602V5.83268Z",
    fill: "#95959B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon-lock.cfa97836ce0280173ad2f808effbb61e.svg";
export { ForwardRef as ReactComponent };